import type { HttpCore } from '../http';

/**
 * The top-level `/grades*` surface — distinct from `portal.getGrades`
 * (`/portal/grades`, the richer MV5 rubric page). This is the legacy
 * `pages/Grades.tsx` + `GradeAppealForm.tsx` appeals surface.
 *
 * `GET /grades` has no current web-ide caller and no confirmed route
 * handler in `services/session-manager` (only `/grades/appeals` and
 * `/grades/submissions/:id/appeals` exist there — see
 * `services/session-manager/src/routes/messaging.ts`). Typed per the §1
 * inventory contract regardless.
 */

export interface Appeal {
  id: string;
  submissionId: string;
  reasonCode: string;
  status: 'submitted' | 'in_review' | 'decided_upheld' | 'decided_revised' | 'withdrawn';
  decidedAt: string | null;
  decisionNotes: string | null;
  createdAt: string;
}

export function createGradesModule(core: HttpCore) {
  return {
    list: () => core.request<unknown>('/grades'),
    listAppeals: () => core.request<{ appeals: Appeal[] }>('/grades/appeals').then((r) => r.appeals ?? []),
    fileAppeal: (submissionId: string, input: { reason_code: string; evidence_text: string }) =>
      core.request<{ appeal: Appeal }>(`/grades/submissions/${encodeURIComponent(submissionId)}/appeals`, {
        method: 'POST',
        body: input,
      }),
  };
}

export type GradesModule = ReturnType<typeof createGradesModule>;
